export default "__VITE_ASSET__BrvRGcM4__"